import { ElasticsearchFieldModel } from '../../../elasticsearch/elasticsearch-field';
import { ElasticsearchEnhancedFilterModel } from '../../../elasticsearch/elasticsearch-filter';
import GreaterThanFilterParser from '../../../osd/filters/parsers/greater-than-filter-parser';
import { BaseExploreFilterParser } from './base';
/**
 * Elastic to ElasticsearchFilterModel 'GREATER THAN' filter parser
 */
export class ExploreFilterGreaterThanFilterParser extends BaseExploreFilterParser {
    constructor() {
        super(new GreaterThanFilterParser());
    }
    getFilter(elasticFilter, negate) {
        const metadata = this.getMetadata(elasticFilter, negate);
        if (!metadata)
            return null;
        const filter = new ElasticsearchEnhancedFilterModel();
        filter.type = 'GREATER_THAN';
        filter.value = metadata.params;
        filter.negate = metadata.negate;
        filter.field = new ElasticsearchFieldModel();
        filter.field.name = metadata.key ?? '';
        return filter;
    }
    getElasticFilter(filter) {
        if (filter.type !== 'GREATER_THAN' || !filter.field)
            return null;
        return { [this.baseFilterParser.elasticKey]: { [filter.field.name]: filter.value } };
    }
}
//# sourceMappingURL=greater-than.js.map